import React, { createContext, useReducer } from 'react'
import AppReducer from './AppReducer'


//INITIAL STATE
const initialState = {
    users: []
}

//CREATE CONTEXT
export const GlobalContext = createContext(initialState) //import this useContext from react in components to access G state

//PROVIDER COMPONENT
export const GlobalProvider = ({children}) => { //children here rep app.js cos GP will wrap the app.js
    
        const [state, dispatch] = useReducer(AppReducer, initialState);
        
        //Actions
        const removeUser = (id) => {
            dispatch({
                type: 'REMOVE_USER',
                payload: id
            })
        }
        const addUser = (user) => {
            dispatch({
                type: 'ADD_USER',
                payload: user
            })
        }
        const editUser = (user) => {
            dispatch({
                type: 'EDIT_USER',
                payload: user
            })
        }
        
    
        return (
            <GlobalContext.Provider value={{users: state.users, removeUser, addUser, editUser}}> 
                {children}
            </GlobalContext.Provider>
        )
    }